import React, { useState, useEffect, useRef } from "react";
import { Link } from "react-router-dom";

const Navbar: React.FC = () => {
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const dropdownRef = useRef<HTMLDivElement>(null);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev);
  };

  // Close dropdown if clicking outside of it
  useEffect(() => {
    const handleClickOutside = (event: MouseEvent) => {
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target as Node)
      ) {
        setIsDropdownOpen(false);
      }
    };
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  return (
    <nav className="p-4 shadow-lg z-10 bg-white">
      <div className="container mx-auto flex w-full justify-between ">
        {/* Desktop Links */}
        <div className="hidden md:flex space-x-4 items-center">
          {/* Logo */}
          <a href="/">
            <img
              src="/umobile-personal.svg"
              alt="U Mobile Logo"
              className="h-10 mr-2"
            />
          </a>
          <Link
            to="/"
            className="text-orange-100 font-medium hover:text-orange-200 transition-colors duration-200"
          >
            Home
          </Link>
          <Link
            to="/about"
            className="text-orange-100 font-medium hover:text-orange-200 transition duration-200"
          >
            About
          </Link>
        </div>

        {/* Mobile Hamburger Icon */}
        <div className="md:hidden flex items-center">
          <button
            onClick={toggleDropdown}
            className="text-orange-100 focus:outline-none"
          >
            <svg
              className="w-6 h-6"
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke="currentColor"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="2"
                d="M4 6h16M4 12h16M4 18h16"
              />
            </svg>
          </button>
          <a href="/">
            <img
               src="./images/umobile-personal.svg"
               alt="U Mobile Logo"
               className="h-10 mr-2"
               />
          </a>
        </div>
      </div>

      {/* Mobile Dropdown Menu */}
      <div
        ref={dropdownRef}
        className={`md:hidden ${isDropdownOpen ? "block" : "hidden"} transition-all ease-in-out duration-300 mt-2`}
      >
        <div className="bg-white shadow-lg rounded-lg p-4">
          <Link
            to="/"
            className="block font-medium text-orange-100 hover:text-orange-200 py-2"
            onClick={() => setIsDropdownOpen(false)} // Close dropdown on link click
          >
            Home
          </Link>
          <Link
            to="/about"
            className="block font-medium text-orange-100 hover:text-orange-200 py-2"
            onClick={() => setIsDropdownOpen(false)} // Close dropdown on link click
          >
            About
          </Link>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
